/**
 * 調試工具 - vConsole 整合
 * 用於在 LINE 環境中查看 console 日誌、網路請求等
 */
import VConsole from 'vconsole'
import { ElMessage } from 'element-plus'
let vConsoleInstance: VConsole | null = null

/**
 * 初始化 vConsole
 * @param forceEnable 是否強制啟用（用於測試）
 */
export function initDebugTool(forceEnable = false) {
  // 檢查是否應該啟用 vConsole
  const shouldEnable =
    forceEnable ||
    import.meta.env.VITE_APP_ENV === 'development' ||
    localStorage.getItem('enableDebug') === 'true'

  if (shouldEnable && !vConsoleInstance) {
    vConsoleInstance = new VConsole({
      theme: 'dark',
      defaultPlugins: ['system', 'network', 'element', 'storage'],
      maxLogNumber: 1000,
      onReady() {
        console.log('🔧 vConsole 已啟動')
      }
    })

    console.log('='.repeat(50))
    console.log('🚀 調試模式已啟用')
    console.log('環境:', import.meta.env.VITE_APP_ENV)
    console.log('版本:', import.meta.env.VITE_APP_VERSION)
    console.log('='.repeat(50))
  }
}

/**
 * 銷毀 vConsole
 */
export function destroyDebugTool() {
  if (vConsoleInstance) {
    vConsoleInstance.destroy()
    vConsoleInstance = null
    console.log('🔧 vConsole 已關閉')
  }
}

/**
 * 切換調試模式
 */
export function toggleDebugMode() {
  const isEnabled = localStorage.getItem('enableDebug') === 'true'

  if (isEnabled) {
    localStorage.removeItem('enableDebug')
    destroyDebugTool()
    ElMessage.info('調試模式已關閉，請重新整理頁面')
  } else {
    localStorage.setItem('enableDebug', 'true')
    initDebugTool()
    ElMessage.success('調試模式已啟用')
  }
}

/**
 * 檢查是否在 LINE 環境中
 */
export function isInLineEnvironment(): boolean {
  const ua = navigator.userAgent.toLowerCase()
  return ua.includes('line/')
}

/**
 * 自動啟用調試工具（如果在 LINE 環境或開發環境）
 */
export function autoInitDebugTool() {
  const isLine = isInLineEnvironment()
  const isDev = import.meta.env.VITE_APP_ENV === 'development'
  const isDebugEnabled = localStorage.getItem('enableDebug') === 'true'

  if (isLine || isDev || isDebugEnabled) {
    initDebugTool()
  }
}
